export default "__VITE_ASSET__BnGUqs3q__"